import { createClient } from "@/shared/urql/urql";
import {
  GetRegistrationDataDocument,
  type RegistrationType,
} from "@/shared/generated/graphql";

export const getRegistrationData = async (
  provisioningKey: string,
  registrationType: RegistrationType,
) => {
  const client = createClient();

  const { error, data } = await client
    .query(GetRegistrationDataDocument, {
      provisioningKey,
      registrationType: registrationType.toUpperCase() as RegistrationType,
    })
    .toPromise();
  const errors = data?.registrationData?.errors;

  if (error) throw error.message;
  if (errors && errors.length > 0) throw errors[0];
  if (!data) throw "INTERNAL_ERROR";

  return data.registrationData?.registrationData || undefined;
};
